var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Категории занятости",
      "create-text": "Новая",
      "fetch-data": _vm.fetchData,
      "route-create": "EmploymentCategoryAdd",
      "route-edit": "EmploymentCategoryEdit",
      "route-view": "EmploymentCategoryView",
      "route-path": "/employment_categories",
      "can-edit": _vm.canEditEmploymentCategoryCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8fc37eec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fc37eec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/EmploymentCategories/EmploymentCategories.vue
// module id = null
// module chunks = 